import { gql } from '@apollo/client'
import { OCCUPANCY_TO_USE_TENANT_FRAGMENT } from 'src/pages/Inbox/components/InboxBody/components/hooks/data/fragments'

export const GET_PERSON = gql`
  query GetPersonForContactDetails($id: Int!) {
    person(id: $id) {
      id
      account_id
      first_name
      last_name
      birthday
      type
      role
      created_at
      updated_at
      pms_id
      daily_action_temp_hold {
        id
        hold_sms
        hold_voicemail
        hold_email
        hold_outbound_call
        ending_at
        reason
      }
      gpt_comms {
        id
        block_gpt
        ending_at
        reason
      }
      account {
        id
        name
        is_pay_ready
        is_res_center
        enable_post_moveout_product
      }
      phones {
        id
        country_code
        phone_number
        is_default
        is_opted_in
        is_valid
        deleted
      }
      sticky_number {
        id
        phone_number
        property {
          id
          name
          enable_eviction
          enable_post_moveout
        }
      }
      payment_promises {
        id
        status
        promise_date
        promise_amount
      }
      automation_person {
        id
        created_at
        status
        removed_by {
          id
          first_name
          last_name
        }
        automation_person_step {
          id
          status
          automation_step {
            id
            action_type {
              id
              name
              description
            }
            rule_type {
              id
              name
              description
            }
          }
        }
        automation {
          name
          id
        }
      }
      emails {
        id
        address
        is_default
        is_opted_in
        deleted
      }
      unit_occupancy_tenants {
        ...occupancyToUseTenantFields
        pms_id
        unit_occupancy {
          id
          pms_id
          status
          lease_from
          lease_to
          rent
          deposit
          current_balance
          move_in
          move_out
          is_active
          deleted
          lease_signed
          last_payment
          last_payment_id
          current_lease
          current_lease_url
          monthly_charges
          is_eviction
          is_collections
          is_cert_funds_only
          allow_online_payment
          require_payment_full
          eligible_renewal
          late_fee_day_of_month
          unit_occupancy_scores {
            id
            score
            score_type
            score_source
            created_at
            updated_at
          }
          updated_at
          payment_pending {
            id
            payment_made_date
            status
            payment_amount
          }
          unit {
            id
            pms_id
            name
            description
            bed
            bathroom
            street_address
          }
          property {
            id
            pms_id
            name
            street_address
            city
            state
            zip
            full_address
            office_email
            office_phone
            late_fee_day_of_month
            portal_url
            enable_post_moveout
            pmo_override_office_email
            pmo_override_office_phone
            pmo_override_portal_url
            portal_close_day_of_month
            is_pay_ready
            account {
              id
              enable_post_moveout_product
            }
            link {
              id
              is_active
            }
            account_integration_properties {
              id
              pms_id
              isActive
              resident_last_sync_completed_at
              property {
                id
              }
              account_integration {
                metadata
                id
                isActive
                integration {
                  id
                  description
                  type
                }
              }
            }
            property_office_hours {
              id
              day_of_week
              is_closed
              open_hour
              closed_hour
              deleted
            }
            timezone
          }
          unit_occupancy_tenants {
            id
            pms_id
            is_active
            deleted
            move_out_date
            person {
              id
              first_name
              last_name
            }
          }
          pay_ready_unit_occupancy_xref {
            id
            pay_ready_lease_id
          }
        }
      }

      conversation {
        id
        actioned
        conversation_reviews {
          id
          actioned_at
          created_at
          reason
        }
      }
      notes {
        id
        content
        created_at
        created_by {
          id
          first_name
          last_name
        }
      }
      person_properties {
        id
        property {
          id
          name
          pms_id
          state
          street_address
          zip
          city
        }
      }
      account_integration {
        id
        isActive
        metadata
        integration {
          id
          type
        }
      }
      pms_id
      language_code
      person_xref_data {
        id
        person_id
        pay_ready_tenant_id
        pay_ready_lease_id
        payment_link
      }
    }
  }
  ${OCCUPANCY_TO_USE_TENANT_FRAGMENT}
`
